import { useEffect, useState } from 'react';
import API from '../../api';

export default function ManagePromotions() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    API.get('promotions/').then((r) => setItems(r.data.results || r.data));
  }, []);

  return (
    <div>
      <div className="page-header">
        <h2><i className="bi bi-mortarboard" /> Promotions</h2>
        <span className="badge-status badge-info">{items.length} promotions (source : fichier référentiel)</span>
      </div>

      <div className="data-table-wrapper">
        <table className="data-table">
          <thead><tr><th>#</th><th>Nom</th></tr></thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan="2"><div className="empty-state"><i className="bi bi-mortarboard" /><p>Aucune promotion</p></div></td></tr>
            ) : items.map((p, i) => (
              <tr key={p.id}>
                <td>{i + 1}</td>
                <td>{p.nom}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
